import React, { useState, useEffect ,useCallback} from "react";
import SchoolHeader from "../../SchoolHeader";
import Footer from "../../Footer";
import HospitalHeader from "../../HospitalHeader";
import { Container, Card, Row, Col } from "react-bootstrap";
import { DataGrid } from "@mui/x-data-grid";
import { FaEye } from "react-icons/fa";
import { useParams } from "react-router-dom";
import schoolServices from "../../../services/school_services";
import hospitalServices from "../../../services/hospital.services";
import LoadingBar from "../toaster/loader/loader";
import { getHospitalSharedDoc, getSchoolSharedDoc } from "../../../services/utils";
import { Input, TextField } from "@mui/material";

import { debounce } from 'lodash';

const SignatureDocsTable = () => {
    const role = localStorage.getItem("PageTittle")
    const [rows, setRows] = useState([])
    const params = useParams()
    const [loadin, Setloading] = useState(false)
    const columns = [
        { field: "student_first_name", headerName: "Student Name", width: 200 },
        { field: "document_name", headerName: "File Name", width: 800 },
      
        {
            field: "action",
            headerName: "Action",
            sortable: false,
            width: 150,
            renderCell: (params) => {

                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        <span className="actn_icn">
                            <FaEye title="Preview"
                              onClick={() => {
                                Setloading(true)
                                if (role === 'Hospital') {
                                    getHospitalSharedDoc({
                                        document: params.row.document_name,
                                        type: "signed_doc",
                                        user_id :params.row.user_id
                                    }).then(resp => {
                                        Setloading(false)
                                    }).catch(err => {
                                        Setloading(false)
                                    })
                                } else {
                                    getSchoolSharedDoc({
                                        document: params.row.document_name,
                                        type: "signed_doc",
                                        user_id :params.row.user_id
                                    }).then(resp => {
                                        Setloading(false)
                                    }).catch(err => {
                                        Setloading(false)
                                    })
                                }
    
                            }
                            }
                            />
                        </span>
                    </div>
                );
            },
        },
    ];
    function contract(query){
        console.log(query,">>>>>query")
        if (role === "Hospital") {
            hospitalServices.getSignaturedDocs(params.folderId,query).then(resp => {

                resp.data.list.map(curr => {
                    curr.id = curr._id
                    setRows(oldRow => ([curr, ...oldRow]))
                })
            })
        }
        else if (role === "School") {
            schoolServices.getSignaturedDocs(params.folderId,query).then(resp => {

                resp.data.list.map(curr => {
                    curr.id = curr._id
                    setRows(oldRow => ([curr, ...oldRow]))
                })
            })
        }
    }

    useEffect(() => {
      
        contract()
    }, [])

    const debouncedFunction = useCallback(
        debounce((event) => {
            
            contract(`&search=${event.target.value}`)
        }, 1000),
        []
    );
    return (
        <div className="dashbrd_pg">
            {role === "School" ?
                <SchoolHeader />
                :
                <HospitalHeader />
            }

            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    {loadin &&
                        <LoadingBar />
                    }
                    <div className="prfl_wrap">
                        <Row>
                            <Col sm={12}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="card_hdng">
                                            <h4 className="mb-0">
                                                Files
                                            </h4>
                                            <div className="ml-3">

                                                        <Input type="search" placeholder="search here...." onChange={(event) => {
                                                            debouncedFunction(event);
                                                        }}></Input>
                                                    </div>
                                        </div>
                                        <div className="apprvl_list">
                                            <div
                                                style={{
                                                    height: 400,
                                                    width: "100%",
                                                }}
                                            >
                                                <DataGrid
                                                    rows={rows}
                                                    columns={columns}
                                                    pageSize={5}
                                                    rowsPerPageOptions={[5]}
                                                />
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default SignatureDocsTable;
